import { NgTemplateOutlet } from "@angular/common";
import { booleanAttribute, ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InfoPopoverComponent } from "@kno2/shared/info-popover";
import { FloatLabel } from "primeng/floatlabel";
import { Select } from "primeng/select";
import { FormControlBaseDirective } from "../form-control-base.directive";

let nextId = 0;

@Component({
    selector: "kno2-form-select",
    imports: [FormsModule, Select, FloatLabel, NgTemplateOutlet, InfoPopoverComponent],
    templateUrl: "./form-select.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSelectComponent extends FormControlBaseDirective {
    public readonly options = input<unknown[]>([]);
    public readonly optionLabel = input<string>();
    public readonly optionValue = input<string>();
    public readonly group = input<boolean, unknown>(false, { transform: booleanAttribute });
    public readonly optionGroupLabel = input<string>();
    public readonly optionGroupChildren = input<string>();
    public readonly placeholder = input<string>();
    public readonly inputId = input<string>(`kno2-form-select-${nextId++}`);
    public readonly showClear = input<boolean, unknown>(false, { transform: booleanAttribute });
    public readonly size = input<"small" | "large">();

    protected readonly value = signal<unknown>(null);

    protected applyValue(value: unknown): void {
        this.value.set(value);
    }

    protected handleChange(value: unknown): void {
        this.value.set(value);
        this.emitChange(value);
    }
}
